/** Take in current combatant state and changes from  */
export function getUpdatedCombatantStateFromDescriptionMerge(currentCombatants={}, descriptionCombatants={}) {
    let payload = {...currentCombatants};

    Object.keys(descriptionCombatants).forEach(combId => {
        payload[combId] = {
            ...payload[combId],
            ...descriptionCombatants[combId]
        }
    });

    return payload
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-combatants-state-change.js